export const ADD_USER  = "ADD_USER"
export const ADD_CATEGORY  ="ADD_CATEGORY"
export const ADD_USER_EXPENSE_DETAILS  ="ADD_USER_EXPENSE_DETAILS"
export const ADD_BUDGET = "ADD_BUDGET"

